export const formatTableList = (item) => {
  item.ctr !== undefined && (item.ctr = (item.ctr * 100).toFixed(2) + "%");
  item.activeRate !== undefined && (item.activeRate = (item.activeRate * 100).toFixed(2) + "%");
  item.convertCntRate !== undefined && (item.convertCntRate = (item.convertCntRate * 100).toFixed(2) + "%");
  item.deepConvertRate !== undefined && (item.deepConvertRate = (item.deepConvertRate * 100).toFixed(2) + "%");
  item.downloadStartRate !== undefined && (item.downloadStartRate = (item.downloadStartRate * 100).toFixed(2) + "%");
  item.downloadFinishRate !== undefined && (item.downloadFinishRate = (item.downloadFinishRate * 100).toFixed(2) + "%");
  item.installFinishRate !== undefined && (item.installFinishRate = (item.installFinishRate * 100).toFixed(2) + "%");
  item.attributionConvertRate !== undefined && (item.attributionConvertRate = (item.attributionConvertRate * 100).toFixed(2) + "%");
  item.activePayRate !== undefined && (item.activePayRate = (item.activePayRate * 100).toFixed(2) + "%");
};
